import React, { FC } from 'react'

import { Icon5gSpeedProps } from './Icon5gSpeed.types'
import * as Styled from './styles/Icon5gSpeed.style'

import { nonThemeableRules } from '../../ruleSet'

const Icon5gSpeed: FC<Icon5gSpeedProps> = ({
  size = nonThemeableRules.defaultSize as number as Icon5gSpeedProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: Icon5gSpeedProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M131.84 128H93.72a14 14 0 0 0-3.72-6 14.18 14.18 0 0 0-19.78 20.32 14.1 14.1 0 0 0 10.06 4 4 4 0 1 0 .09-8h-.2a6.18 6.18 0 0 1-4.39-1.75 6.18 6.18 0 0 1 8.62-8.86 6.16 6.16 0 0 1 1.89 4.37 4 4 0 0 0 4 3.92l41.47.05a4 4 0 1 0 .18-8h-.17zM80 91.3a4 4 0 0 0 4-4v-8.94a4 4 0 0 0-8 0v8.94a4 4 0 0 0 4 4zM35.29 128h-8.94a4 4 0 1 0 0 8h8.94a4 4 0 0 0 0-8zm9.54-36.83a4 4 0 0 0-5.66 5.66l6.71 6.71a4 4 0 1 0 5.66-5.66zm76.71 5.66a4 4 0 1 0-5.66-5.66l-6.71 6.71a4 4 0 1 0 5.66 5.66z' />
        <path d='M154.25 148.25A76 76 0 1 0 5.7 148m114.72-98.59 23.57-4.5-4.49-23.57M11.71 48.29a108 108 0 0 1 129-5.61' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default Icon5gSpeed
